export default class MainNavigation {
    constructor() {
        this.init()
    }

    init() {
        this.isSticky = false
        this.navEl = document.querySelector('.nav')
        this.wrapperEl = document.querySelector('.wrapper')
        this.headerEl = document.querySelector('header')

        if (this.navEl && this.headerEl && this.wrapperEl) {
            const headerObserver = new IntersectionObserver((records, observer) => {
                for (const record of records) {
                    if (record.isIntersecting && this.isSticky) {
                        this.stickyNav(false)
                    } else if (!record.isIntersecting && !this.isSticky) {
                        this.stickyNav(true)
                    }
                }
            })
            headerObserver.observe(this.headerEl)
        }
    }
    stickyNav(state) {
        this.isSticky = state
        if (state) {
            this.wrapperEl.style.paddingTop = `${this.navEl.offsetHeight}px`
            this.navEl.classList.add('fixed-nav')
        } else {
            this.wrapperEl.style.paddingTop = 0
            this.navEl.classList.remove('fixed-nav')
        }
    }
}
